import { GetByIdentityRequest } from '@nts/std';
import { MenuNodeIdentity } from '../domain-models/menu-node.identity';

export class GetChildrenRequest extends GetByIdentityRequest<MenuNodeIdentity> {

}
